"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.titleIcons = void 0;
var _icons = require("@ori-ui/icons");
var _types = require("./types");
const titleIcons = exports.titleIcons = {
  [_types.NewsletterTitleIconType.Submit]: _icons.Send,
  [_types.NewsletterTitleIconType.Subscribe]: _icons.CheckCircle,
  [_types.NewsletterTitleIconType.Error]: _icons.ErrorCircle
};
